var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTariffs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 7H19V8H9V7Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7H19V8H9V7Z",
    fill: "#74A3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7V6H8V7H9ZM19 7H20V6H19V7ZM19 8V9H20V8H19ZM9 8H8V9H9V8ZM9 8H19V6H9V8ZM18 7V8H20V7H18ZM19 7H9V9H19V7ZM10 8V7H8V8H10Z",
    fill: "#74A3C7",
    mask: "url(#path-1-inside-1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19H16V20H9V19Z",
    fill: "#74A3C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22H16V23H9V22Z",
    fill: "#74A3C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H23V11H9V10Z",
    fill: "#74A3C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H16V14H9V13Z",
    fill: "#74A3C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16H16V17H9V16Z",
    fill: "#74A3C7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 18,
    width: 2,
    height: 2,
    fill: "#74A3C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 21,
    width: 2,
    height: 2,
    fill: "#74A3C7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 24,
    width: 2,
    height: 2,
    fill: "#74A3C7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 18,
    width: 2,
    height: 2,
    fill: "#74A3C7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 2,
    height: 2,
    fill: "#74A3C7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 24,
    width: 2,
    height: 2,
    fill: "#74A3C7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 18,
    width: 2,
    height: 2,
    fill: "#74A3C7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 21,
    width: 2,
    height: 5,
    fill: "#74A3C7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 14.5,
    width: 7,
    height: 2,
    stroke: "#74A3C7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 12.5,
    width: 11,
    height: 15,
    stroke: "#74A3C7",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6074 4.11718L24.8801 7.31721C24.9554 7.39277 24.9971 7.4945 24.9964 7.6H25V12H24.1818V7.99997H21.3182C21.0922 7.99997 20.909 7.821 20.909 7.6V4.80003H7.81821V27.2H17V28L7.40906 28C7.18304 28 7 27.821 7 27.6V4.39997C7 4.17898 7.18304 4 7.40906 4H21.3182V4.00352C21.4262 4.00216 21.5305 4.04298 21.6074 4.11718ZM23.6034 7.20003L21.7273 5.36561V7.20003H23.6034Z",
    fill: "#74A3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariffs);
export default __webpack_public_path__ + "static/media/tariffs.fc7beda56ae74e3c915272159fc981ef.svg";
export { ForwardRef as ReactComponent };